import { ComputersAndVirtualMachinesWebComponent } from './component/ComputersAndVirtualMachinesWebComponent';
import { WEB_COMPONENT_COMPUTERS_AND_VIRTUAL_MACHINES } from '../../webcomponents.constants';

export { ComputersAndVirtualMachinesWebComponent };

window.customElements.define(WEB_COMPONENT_COMPUTERS_AND_VIRTUAL_MACHINES, ComputersAndVirtualMachinesWebComponent);
